import { NewsletterViewApiType } from 'modules/newsletters/single/types/newsletter-view-interface'
import { useEffect, useState } from 'react'
import { ContactsSettings } from 'shared/components/dashboard-mail-editor/components/contacts-settings-block'

export const useNewsletterContactsSettings = (newsletterData: NewsletterViewApiType) => {
  const [contactsSettings, setContactsSettings] = useState<ContactsSettings>({
    daysExists: 0,
    tags: { included: [], excluded: [] },
  })

  useEffect(() => {
    setContactsSettings({
      daysExists: newsletterData.daysExists,
      tags: {
        included: newsletterData?.tags?.map(({ id }) => id) || [],
        excluded: newsletterData?.excludedTags?.map(({ id }) => id) || [],
      },
    })
  }, [newsletterData])

  return { contactsSettings, setContactsSettings }
}
